module.exports = __webpack_public_path__ + "static/img/img_yellow.f210fab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img_yellow.png
// module id = VZKr
// module chunks = 1